import React from 'react';

const InfoSection = ({ info }) => (
  <div className='p-4'>
    <h3>Info:</h3>
    <p>{info}</p>
  </div>
);
export default InfoSection;
